"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoTileWasRemovedHandler = videoTileWasRemovedHandler;
exports.videoTileWasRemovedHandlerForMixer = videoTileWasRemovedHandlerForMixer;
var _StudioLogger = require("@studio/logger/StudioLogger");
var _logger = require("../../../constants/logger");
var logger = new _StudioLogger.StudioLogger(_logger.loggerName);
function videoTileWasRemovedHandler(meetingResponse, attendeeResponse) {
  return function videoTileWasRemovedHandler(tileId) {
    var meetingId = meetingResponse.Meeting.MeetingId;
    var attendeeId = attendeeResponse.Attendee.AttendeeId;
    var logPayload = {
      chimeEventName: 'videoTileWasRemoved',
      'tile-id': tileId,
      'studio.meeting.id': meetingId,
      title: "Tile id: ".concat(tileId, " removed from meeting id: ").concat(meetingId, " by attendee ").concat(attendeeId)
    };
    logger.info(logPayload.title, logPayload);
  };
}
function videoTileWasRemovedHandlerForMixer(meetingResponse, attendeeResponse, meetingSession, setAttendeeCameraStatus, attendeeCameraStatusHandler, dispatch) {
  return function videoTileWasRemovedHandler(tileId) {
    var meetingId = meetingResponse.Meeting.MeetingId;
    var attendeeId = attendeeResponse.Attendee.AttendeeId;
    var logPayload = {
      chimeEventName: 'videoTileWasRemoved',
      'tile-id': tileId,
      'studio.meeting.id': meetingId,
      title: "Tile id: ".concat(tileId, " removed from meeting id: ").concat(meetingId, " by attendee ").concat(attendeeId)
    };
    logger.info(logPayload.title, logPayload);
    attendeeCameraStatusHandler(meetingSession, dispatch, setAttendeeCameraStatus);
  };
}